import React from "react";
import { MapPin, GraduationCap, Mail, Users, User } from "lucide-react";
import jorge from "../img/seminario/jorge.jpeg";
import freddy from "../img/seminario/freddy.jpeg";
import maria from "../img/seminario/maria.jpg";
import pablo from "../img/seminario/pablo.png";
// Datos del equipo organizador con retratos profesionales de alta calidad
const miembrosEquipo = [
  {
    id: 1,
    nombre: "Ronny Correa Quezada",
    institucion: "Universidad Técnica Particular de Loja",
    siglas: "UTPL",
    pais: "Ecuador",
    rol: "Coordinador General",
    correo: "racorrea@utpl.edu.ec",
    color: "from-blue-500 to-indigo-600",
    foto: "https://sica.utpl.edu.ec/media/uploads/docentes/fotos/web/low/1102755558_low.jpg",
  },
  {
    id: 2,
    nombre: "Pablo Cardoso Terán",
    institucion: "Facultad Latinoamericana de Ciencias Sociales",
    siglas: "FLACSO",
    pais: "Ecuador",
    rol: "Coordinador del Comité Académico",
    correo: "pcardoso@flacso.edu.ec",
    color: "from-emerald-500 to-teal-600",
    foto: pablo,
  },
  {
    id: 3,
    nombre: "María del Cisne Tituaña",
    institucion: "Universidad Técnica Particular de Loja",
    siglas: "UTPL",
    pais: "Ecuador",
    rol: "Coordinadora de Logística",
    correo: "mctituana@utpl.edu.ec",
    color: "from-purple-500 to-pink-600",
    foto:  maria,
  },
  {
    id: 4,
    nombre: "Fredy Gómez",
    institucion: "Universidad Técnica Particular de Loja",
    siglas: "UTPL",
    pais: "Ecuador",
    rol: "Comité Técnico & Sistemas",
    correo: "fgomez@utpl.edu.ec",
    color: "from-amber-500 to-orange-600",
    foto: freddy,
  },
  {
    id: 5,
    nombre: "Jorge Flores",
    institucion: "Universidad Técnica Particular de Loja",
    siglas: "UTPL",
    pais: "Ecuador",
    rol: "Comité de Difusión y Comunicación",
    correo: "jflores@utpl.edu.ec",
    color: "from-rose-500 to-red-600",
    foto: jorge,
  },
  {
    id: 6,
    nombre: "Verónica Noriega",
    institucion: "Universidad Técnica Particular de Loja",
    siglas: "UTPL",
    pais: "Ecuador",
    rol: "Coordinadora de Relaciones Internacionales",
    correo: "vnoriega@utpl.edu.ec",
    color: "from-cyan-500 to-blue-600",
    foto: "https://sica.utpl.edu.ec/media/uploads/docentes/fotos/web/low/noriega_low.jpg",
  },
  {
    id: 7,
    nombre: "Christian Viñán",
    institucion: "Universidad Técnica Particular de Loja",
    siglas: "UTPL",
    pais: "Ecuador",
    rol: "Comité Editorial",
    correo: "cvinan@utpl.edu.ec",
    color: "from-violet-500 to-fuchsia-600",
    foto: "https://sica.utpl.edu.ec/media/uploads/docentes/fotos/web/low/1103346415_low.jpg",
  },
];

// Componente para manejar la imagen grande (tarjeta superior) con fallback
function FotoMiembro({ url, nombre, color }) {
  const [error, setError] = React.useState(false);

  if (error || !url) {
    return (
      <div
        className={`w-full aspect-square bg-gradient-to-br ${color} flex flex-col items-center justify-center text-white p-4`}
      >
        <User className="w-16 h-16 opacity-80 mb-2" />
        <span className="text-xs font-semibold tracking-wider uppercase opacity-75">
          Sin foto disponible
        </span>
      </div>
    );
  }

  return (
    <div className="relative w-full aspect-square overflow-hidden bg-slate-100">
      <img
        src={url}
        alt={`Fotografía de ${nombre}`}
        onError={() => setError(true)}
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
    </div>
  );
}

export default function Equipo() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans">
      {/* Sección Hero */}
      <section className="relative overflow-hidden py-12 lg:py-16">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-4 text-slate-900">
            Equipo organizador
          </h1>
          <p className="text-base text-slate-600 max-w-xl mx-auto leading-relaxed">
            Docentes e investigadores comprometidos con el desarrollo científico
            y la vinculación académica internacional.
          </p>
        </div>
      </section>

      {/* Grid de Miembros */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {miembrosEquipo.map((miembro) => (
            <div
              key={miembro.id}
              className="group relative rounded-2xl border bg-white border-slate-200 shadow-sm overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
            >
              {/* Imagen de cabecera con badge flotante */}
              <div className="relative">
                <FotoMiembro
                  url={miembro.foto}
                  nombre={miembro.nombre}
                  color={miembro.color}
                />
                <span
                  className={`absolute top-3 right-3 z-10 text-[10px] font-extrabold px-3 py-1 rounded-full shadow-sm backdrop-blur-md bg-white/90 ${
                    miembro.siglas === "UTPL"
                      ? "text-amber-600 border border-amber-200"
                      : "text-emerald-600 border border-emerald-200"
                  }`}
                >
                  {miembro.siglas}
                </span>
              </div>

              {/* Contenido / Cuerpo de la Card */}
              <div className="p-5">
                {/* Información de Identidad */}
                <h3 className="font-bold text-base tracking-tight mb-1 text-slate-900 group-hover:text-blue-600 transition-colors">
                  {miembro.nombre}
                </h3>
                <p className="text-xs font-bold text-blue-600 mb-3 uppercase tracking-wide">
                  {miembro.rol}
                </p>

                <hr className="my-3 border-slate-100" />

                {/* Institución e información adicional */}
                <div className="space-y-2 mb-4">
                  <div className="flex items-start text-xs text-slate-500">
                    <GraduationCap className="w-3.5 h-3.5 mr-2 shrink-0 mt-0.5 text-slate-400" />
                    <span className="leading-relaxed font-medium">
                      {miembro.institucion}
                    </span>
                  </div>
                  <div className="flex items-center text-xs text-slate-450 text-slate-500">
                    <MapPin className="w-3.5 h-3.5 mr-2 shrink-0 text-slate-400" />
                    <span>{miembro.pais}</span>
                  </div>
                </div>

                {/* Botón de Correo Directo */}
                <a
                  href={`mailto:${miembro.correo}`}
                  className="w-full py-2.5 px-3 rounded-xl text-xs font-semibold flex items-center justify-center gap-2 border border-slate-200 bg-slate-50 text-slate-600 hover:bg-slate-100 hover:text-slate-950 transition-all"
                >
                  <Mail className="w-3.5 h-3.5 text-slate-400" />
                  <span className="truncate">{miembro.correo}</span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
